import React, {Component, createRef} from 'react';
import CountUp from 'react-countup';

class Count extends Component {
    constructor({currency_symbol}) {
        super();

        this.currency_symbol = currency_symbol;

        this.state = {
            from: 0,
            to: 0
        }
    }

    render() {
        let {from, to} = this.state;

        return (
            <CountUp
                start={from}
                end={to}
                duration={1}
                decimals={2}
                separator={','}>
                {({countUpRef}) => (
                    <div className="amount">
                        <span ref={countUpRef}></span> {this.currency_symbol}
                    </div>
                )}
            </CountUp>
        )
    }

    componentDidUpdate(prevProps) {
        const prev_value = prevProps.value,
              curr_value = this.props.value;

        if(prev_value !== curr_value)
            this.setState({
                from: prev_value,
                to: curr_value
            });
    }

    componentDidMount() {
        this.setState({
            from: 0,
            to: this.props.value
        })
    }
}

export default Count;